/**
 * Cache Updater
 * Update cached location data
 */

import { state } from '../core/state.js';

/**
 * Update cached location with geocode result
 * @param {Object} geocodedData
 */
export function updateCachedLocationWithGeocode(geocodedData) {
  // Wrapper for CampsUtils function
  if (!window.CampsUtils?.updateCachedLocationWithGeocode) {
    console.warn('CampsUtils.updateCachedLocationWithGeocode not available');
    return;
  }

  // Determine userLocation based on search type
  let userLocationForCache = state.zip; // Default: use the original query

  // If this was a camp search (dual search), use the camp's location instead of camp name
  if (
    state.geocodeResult?.isCampFound &&
    state.geocodeResult?.correctedCity &&
    state.geocodeResult?.correctedState
  ) {
    userLocationForCache = `${state.geocodeResult.correctedCity}, ${state.geocodeResult.correctedState}`;
    console.log(
      '✅ Using camp location for cache:',
      userLocationForCache,
      'instead of camp name:',
      state.zip
    );
  } else if (
    state.geocodeResult?.isCampFound &&
    state.geocodeResult?.correctedCity
  ) {
    userLocationForCache = state.geocodeResult.correctedCity;
    console.log(
      '✅ Using camp city for cache:',
      userLocationForCache,
      'instead of camp name:',
      state.zip
    );
  }

  window.CampsUtils.updateCachedLocationWithGeocode(
    geocodedData,
    userLocationForCache
  );
  console.log('💾 Location cache updated');
}

console.log('📦 Cache updater module loaded');
